"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minibagWidthStyle = exports.Root = exports.ItemsWrapper = exports.Items = exports.EmptyBag = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const minibagWidthStyle = exports.minibagWidthStyle = 'var(--minibag-desktop-width, 400px)';
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme,
  ownerState
}) => ({
  ..._constants.basePositionStyles,
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  left: 'auto',
  maxWidth: 'calc(100vw - 40px)',
  width: ownerState.useOpenedMinibagOnDesktop && ownerState.breakpointIndex === 2 ? minibagWidthStyle : '400px',
  zIndex: 1
}));
const ItemsWrapper = exports.ItemsWrapper = (0, _mui.styled)(_mui.ScopedCssBaseline)(({
  theme
}) => ({
  position: 'relative',
  display: 'block',
  boxSizing: 'border-box',
  overflow: 'hidden',
  flex: 1,
  background: theme.palette.background.paper
}));
const EmptyBag = exports.EmptyBag = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'inherit',
  top: '40%',
  textAlign: 'center',
  color: theme.palette.text.secondary
}));
const Items = exports.Items = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  maxHeight: '100%',
  overflow: 'auto',
  paddingTop: theme.spacing(13),
  paddingBottom: theme.spacing(15),
  overscrollBehavior: 'contain'
}));
